import IpsLink from './IpsLink.vue';
import '../../../styles/custom.scss';

export default IpsLink;
